<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | ${title}` : `${title}`
    }}</template>
  </metainfo>
  <router-view v-if="isTokenChecked" />
  <div v-else class="page-loading">
    <div class="page-loader">
      <span class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";
import { useMeta } from "vue-meta";
import packageJson from "../package.json";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    const title = store.getters["platform/config"]?.appTitle;
    useMeta({
      title,
    });

    const isTokenChecked = computed(() => {
      return store.getters["tokens/isTokenChecked"];
    });

    onMounted(() => {
      console.log("Application loaded, version " + packageJson.version);
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      nextTick(() => {
        initializeComponents();
      });
    });
    return {
      isTokenChecked,
      title,
    };
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~apexcharts/dist/apexcharts.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~@vueform/slider/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
@import "~element-plus/dist/index.css";

// Main demo style scss
@import "assets/sass/plugins";
@import "assets/sass/style";

// Dark mode demo style scss
//@import "assets/sass/plugins.dark";
//@import "assets/sass/style.dark";

//RTL version styles
//@import "assets/css/style.rtl.css";
</style>
